import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AnalyticsService';
import { EventRepository } from '~repositories/EventRepository';
import { Event } from '~entities/Event';
import { LoyaltyEventAction } from '~constants/Loyalty';

export class LoyaltyPointsUseCase {
    private eventRepository: EventRepository;
    private loyaltyActivityData: string;
    private loyaltyPointsEventData: string;

    constructor(loyaltyActivityData: string, loyaltyPointsEventData: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.loyaltyActivityData = loyaltyActivityData;
        this.loyaltyPointsEventData = loyaltyPointsEventData;
    }

    public execute() {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: this.loyaltyPointsEventData,
            type: 'link',
            payload: this.getLoyaltyPointsHistoryPayload()
        });
        this.eventRepository.addEventToQueue(newEvent);
    }

    private getLoyaltyPointsHistoryPayload() {
        return {
            event_name: LoyaltyEventAction.LOYALTY_EVENT_PAGE,
            event_category: LoyaltyEventAction.LOYALTY_EVENT_PAGE,
            event_action: LoyaltyEventAction.LOYALTY_POINTS_TEXT,
            event_label: this.loyaltyActivityData
        };
    }
}
